import type { ReactNode } from "react";

/** A small rounded label. Lives in its own file so both the list rows and the agentic status pieces can use it. */
export function Chip({ className = "", children, title }: { className?: string; children: ReactNode; title?: string }) {
  return (
    <span
      title={title}
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium ${className}`}
    >
      {children}
    </span>
  );
}
